// please be familiar with react-bootstrap-table-next column formaters
// https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html?selectedKind=Work%20on%20Columns&selectedStory=Column%20Formatter&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import {Badge} from 'react-bootstrap';
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";

export function ImageColumnFormatter(
    cellContent,
    row,
    rowIndex,
    {previewClick, deleteClick, featuredClick, title, featuredImage}
) {

    return (
        <>
            {/*{(featuredImage && featuredImage.id === row.id)*/}
            {/*    ? <>*/}
            {/*        <Badge variant={'success'}>*/}
            {/*            <span className="svg-icon svg-icon-md svg-icon-primary">*/}
            {/*                تصویر اصلی*/}
            {/*              <SVG*/}
            {/*                  src={toAbsoluteUrl("/media/svg/icons/General/Start.svg")}*/}
            {/*              />*/}
            {/*            </span>*/}
            {/*        </Badge>*/}
            {/*    </>*/}
            {/*    : <>*/}
            {/*        <a*/}
            {/*            title={`Featured image`}*/}
            {/*            className="btn btn-light btn-hover-primary btn-sm mx-3"*/}
            {/*            onClick={() => featuredClick(row.id)}*/}
            {/*        >*/}
            {/*            <span className="svg-icon svg-icon-md svg-icon-primary">*/}
            {/*                تصویر اصلی*/}
            {/*              <SVG*/}
            {/*                  src={toAbsoluteUrl("/media/svg/icons/General/Star.svg")}*/}
            {/*              />*/}
            {/*            </span>*/}
            {/*        </a>*/}
            {/*    </>*/}
            {/*}*/}

            <a
                title={`Edit ${title}`}
                className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                onClick={() => previewClick(row.id)}
            >
                <span className="svg-icon svg-icon-md svg-icon-primary">
                  <SVG
                      src={toAbsoluteUrl("/media/svg/icons/General/Visible.svg")}
                  />
                </span>
            </a>
            {/*<a*/}
            {/*    title={`Delete ${title}`}*/}
            {/*    className="btn btn-icon btn-light btn-hover-danger btn-sm"*/}
            {/*    onClick={() => deleteClick(row.id)}*/}
            {/*>*/}
            {/*    <span className="svg-icon svg-icon-md svg-icon-danger">*/}
            {/*      <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}/>*/}
            {/*    </span>*/}
            {/*</a>*/}
        </>
    );
}
